var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgE2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.007 59.9957C120.007 26.8586 93.1439 -0.00433757 60.0068 -0.00433612C26.8697 -0.00433467 0.00683187 26.8586 0.00683331 59.9957C0.00683476 93.1328 26.8698 119.996 60.0068 119.996C93.1439 119.996 120.007 93.1328 120.007 59.9957Z",
    fill: "#FFA360"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8929 48.8127C47.8929 53.2942 44.7039 56.9306 40.7764 56.9306C36.8488 56.9306 33.6599 53.2942 33.6599 48.8127C33.6599 44.3311 36.8488 40.6948 40.7764 40.6948C44.7039 40.6948 47.8929 44.3311 47.8929 48.8127Z",
    fill: "#939598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3587 48.8127C86.3587 53.2942 83.1698 56.9306 79.2422 56.9306C75.3147 56.9306 72.1257 53.2942 72.1257 48.8127C72.1257 44.3311 75.3147 40.6948 79.2422 40.6948C83.1698 40.6948 86.3587 44.3311 86.3587 48.8127Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4566 37.7686C42.4098 35.7729 38.7805 34.8425 35.1442 35.1266C33.8871 35.2189 32.6228 34.4874 32.3246 33.28C32.0192 32.0797 33.1271 30.7729 34.7961 30.645C39.4197 30.2899 44.0362 31.4689 47.914 34.0115C49.3203 34.9277 49.6612 36.611 48.816 37.5129C47.9709 38.422 46.5149 38.4575 45.4566 37.7686Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5547 37.7686C77.6016 35.7729 81.2308 34.8425 84.8672 35.1266C86.1243 35.2189 87.3885 34.4874 87.6868 33.28C87.9922 32.0797 86.8843 30.7729 85.2152 30.645C80.5917 30.2899 75.9752 31.4689 72.0973 34.0115C70.6911 34.9277 70.3502 36.611 71.1953 37.5129C72.0405 38.422 73.4965 38.4575 74.5547 37.7686Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3019 83.1522C53.0846 77.03 66.9269 77.03 78.7167 83.1522C80.6556 84.1607 81.4155 86.3908 80.4993 87.9036C79.5831 89.4235 77.5874 89.8212 75.9823 88.9902C65.9184 83.763 54.1002 83.763 44.0363 88.9902C42.4241 89.8212 40.4354 89.4164 39.5192 87.9036C38.603 86.3908 39.363 84.1607 41.3019 83.1522Z",
    fill: "#939598"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE2);
export default __webpack_public_path__ + "static/media/E2.0bf86fb03aca8a96eaea8350d99a54d7.svg";
export { ForwardRef as ReactComponent };